export const route = 'editor' as const;
export const path = '/' as const;
